import React from "react";
import type { Dispatch, SetStateAction } from "react";
import { CircularProgress, Tooltip, Box } from "@mui/joy";
import { VisibilityIcon } from "../../../styles/StyledMUI";
import { useAlert } from "../../../contexts/app/notificationToast";
import DarkTypography from "../../common/DarkTypography";
import IconButtonCTA from "../../common/IconButtonCTA";
import { roundActionIconButtonSx } from "../../../styles/globalStyles";
import DocumentUploadButtons from "./DocumentUploadButtons";

type FileComponentProps = {
  file: File | string | undefined;
  setFile: Dispatch<SetStateAction<File | string | undefined>>;
  title: string | undefined;
};

export default function FileComponent({ file, setFile }: FileComponentProps) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { showAlert } = useAlert();

  const viewFile = () => {
    if (typeof file === "string") {
      window.open(file, "_blank", "noopener,noreferrer");
    } else if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box sx={{ padding: 1 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
        }}
      >
        {!isLoading ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
            <Box display="flex" alignItems="center" gap={2}>
              <DocumentUploadButtons
                onFile={setFile}
                onInvalidFile={() =>
                  showAlert("PDF ou photo requis (image illisible refusée).", "warning")
                }
                onLoadingChange={setIsLoading}
              />

              {file && (
                <Tooltip title="Voir le document">
                  <IconButtonCTA
                    onClick={viewFile}
                    size="lg"
                    ctaVariant="accent"
                    aria-label="Voir le document"
                    sx={roundActionIconButtonSx}
                  >
                    <VisibilityIcon />
                  </IconButtonCTA>
                </Tooltip>
              )}
            </Box>

            {file ? (
              <DarkTypography level="body-xs" colorVariant="secondary" sx={{ fontSize: "12px" }}>
                Document renseigné
              </DarkTypography>
            ) : (
              <DarkTypography level="body-xs" colorVariant="muted" sx={{ fontSize: "12px" }}>
                Aucun document
              </DarkTypography>
            )}
          </Box>
        ) : (
          <CircularProgress size="lg" />
        )}
      </Box>
    </Box>
  );
}
